import { createDomain } from 'effector';

const domain = createDomain('dashboard');

const $$dashboard = {
    $initialProduct: domain.createStore<string | null>(null),
};

export default $$dashboard;
